import { defineStore } from "pinia";
import { useLocalStorage } from "@vueuse/core";

export const useAppStore = defineStore("app", () => {
  const redirectUrl = useLocalStorage<string | null>("redirectUrl", null);

  const setRedirectUrl = () => {
    const pathname = window.location?.pathname;
    const isToAuth = pathname?.includes("/auth/");

    if (pathname && pathname !== "/" && !isToAuth) {
      redirectUrl.value = pathname;
    }
  };

  const clearRedirectUrl = () => {
    redirectUrl.value = null;
  };

  return {
    redirectUrl,
    setRedirectUrl,
    clearRedirectUrl,
  };
});
